module.exports = __webpack_public_path__ + "static/media/funnel-dollar.91b94eb7.svg";